import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, mergeProps as _mergeProps, unref as _unref, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "exam-box",
  cytag: "exam-item"
}
const _hoisted_2 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_3 = { class: "ms-3" }
const _hoisted_4 = {
  key: 0,
  class: "gray-format"
}
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = { class: "exam-title" }
const _hoisted_7 = {
  key: 1,
  class: "gray-format"
}
const _hoisted_8 = {
  key: 2,
  class: "caption"
}
const _hoisted_9 = { class: "ranking me-2" }
const _hoisted_10 = { class: "ranking me-2" }
const _hoisted_11 = { class: "d-flex" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "retest-menu" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "me-5 exam-title text-blue" }
const _hoisted_17 = {
  key: 0,
  class: "gray-format"
}
const _hoisted_18 = { class: "d-flex align-center" }
const _hoisted_19 = {
  key: 0,
  class: "average-score"
}
const _hoisted_20 = {
  key: 1,
  class: "me-5"
}

import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import ProgressRotate from '../atoms_molecules/ProgressRotate.vue'
import DialogDeleteConfirm from '../atoms_molecules/DialogDeleteConfirm.vue'
import DialogDeleteExamConfirm from '../atoms_molecules/DialogDeleteExamConfirm.vue'
import { format } from 'date-fns'
import { useExam } from './useExam'
import Exam from '../../models/exam'
import UserExam from '../../models/user_exam'
import { ROUTER_NAME } from '../../router'
import SchoolSetting from '../../../api/v2/models/school_setting'
import flatten from 'lodash/flatten'

interface HistoryType {
  exam: Exam
  userExam: UserExam
  btnName: string
  title?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Exam',
  props: {
    exam: {},
    list: { default: () => [] },
    isMine: { type: Boolean, default: false },
    schoolSetting: {},
    onShowHistories: { type: [Function, null], default: null },
    onlyAction: { type: Boolean, default: false },
    userExam: { default: null }
  },
  emits: ["fetchList"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const router = useRouter()
const { t } = useI18n()

const {
  TYPE_USE_NIGATE_EXAM,
  TYPE_USE_SPECIAL_EXAM,
  TYPE_USE_EXAM_FROM_FAILED,
  gotoExam,
  reTest: reTestFn,
  confimClearHistoryTest: confimClearHistoryTestFn
} = useExam()

const isMobile = ref(false)

const getChildOfExam = (exam: Exam, examList: Exam[]): Exam[] => {
  const childOfExams = examList.filter((item) => item.parentId == exam.id)
  return flatten([childOfExams, ...childOfExams.map((child) => getChildOfExam(child, examList))])
}

const childrenExams = computed(() => getChildOfExam(props.exam, props.list))

const allHistories = computed<HistoryType[]>(() => {
  const histories: HistoryType[] = []

  props.exam.userExams.forEach((userExam) => {
    histories.push({
      exam: props.exam,
      userExam,
      btnName: btnName(props.exam, userExam)
    })
  })

  childrenExams.value.forEach((exam) => {
    exam.userExams.forEach((userExam) => {
      histories.push({
        exam,
        userExam,
        btnName: btnName(exam, userExam)
      })
    })
  })

  let ascHistories = histories.sort((a, b) => {
    if (a.userExam.createdAt < b.userExam.createdAt) {
      return -1
    }
    if (a.userExam.createdAt == b.userExam.createdAt) {
      return 0
    }
    return 1
  })

  const testFromFaildExam: Exam[] = []
  const result: HistoryType[] = []
  ascHistories.forEach((history, index) => {
    let title = ''
    if (index == 0) {
      testFromFaildExam.push(history.exam)
      title = history.exam.name
    } else if (testFromFaildExam.find((item) => item.id == history.exam.id)) {
      title = `再テスト${index} − 同じ問題`
    } else {
      testFromFaildExam.push(history.exam)
      switch (history.exam.examType) {
        case Exam.TYPE_USE_NIGATE_EXAM:
          title = `再テスト${index} − ニガテ`
          break
        case Exam.TYPE_USE_SPECIAL_EXAM:
          title = `再テスト${index} − 別質問`
          break
        case Exam.TYPE_USE_EXAM_FROM_FAILED:
          title = `再テスト${index} − 前回マチガイ再テスト`
          break
        default:
          title = `再テスト${index}`
          break
      }
    }

    result.push({
      ...history,
      title
    })
  })

  return result.reverse()
})

const latestHistory = computed(() => allHistories.value[0])
const showingHistories = computed(() => allHistories.value.slice(1, allHistories.value.length))
const oldestHistory = computed(() => allHistories.value[allHistories.value.length - 1])
const isNoHistory = computed(() => allHistories.value.length == 1)

const currentUserExam = computed(() => {
  return props.userExam ? props.userExam : latestHistory.value.userExam
})

const isShowResult = computed(() => {
  return (
    latestHistory.value.exam.isDone(currentUserExam.value) &&
    !currentUserExam.value.isWaitingScoreCheck &&
    !latestHistory.value.exam.hideResult
  )
})

const dateFormat = (date: Date) => {
  return format(date, 'YYYY/MM/DD HH:mm')
}

const btnName = (exam: Exam, userExam: UserExam) => {
  if (!exam.isStarted(userExam)) {
    return t('exam_list.start') as string
  }
  if (exam.isTestTimeOver(userExam)) {
    return t('exam_list.time_over') as string
  }
  return t('exam_list.continue') as string
}

const onResize = () => {
  isMobile.value = window.innerWidth < 600
}

const goToUserExamHistory = (exam: Exam, userExam: UserExam) => {
  if (currentUserExam.value.isWaitingScoreCheck) return

  router.push({
    name: userExam.finishedAt ? ROUTER_NAME.EXAM_RESULT : ROUTER_NAME.EXAM_SHOW,
    params: {
      examId: exam.id.toString()
    },
    query: {
      user_exam_id: userExam.id.toString()
    }
  })
}

const reTest = (exam: Exam, examType: string = '') => {
  reTestFn(exam, examType)
}

const confimClearHistoryTest = (userExam: UserExam) => {
  confimClearHistoryTestFn(userExam, emit)
}

onMounted(() => {
  onResize()
  window.addEventListener('resize', onResize)
})

onBeforeUnmount(() => {
  if (typeof window !== 'undefined') {
    window.removeEventListener('resize', onResize)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(`d-flex p-2 exam-test ${__props.onlyAction ? 'justify-center' : 'justify-space-between'} ${currentUserExam.value.isWaitingScoreCheck ? 'disabled' : ''}`),
      onClick: _cache[8] || (_cache[8] = ($event: any) => (goToUserExamHistory(latestHistory.value.exam, currentUserExam.value)))
    }, [
      (!__props.onlyAction)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_v_img, {
              width: isMobile.value ? 40 : 70,
              height: isMobile.value ? 40 : 70,
              src: 
            latestHistory.value.exam.image && latestHistory.value.exam.image.url
              ? latestHistory.value.exam.image.url
              : latestHistory.value.exam.examImageUrl
          
            }, null, 8 /* PROPS */, ["width", "height", "src"]),
            _createElementVNode("div", _hoisted_3, [
              (!isNoHistory.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(latestHistory.value.title), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_5, [
                _createCommentVNode(" <template v-if=\"isShowResult\">\n              <v-icon v-if=\"latestHistory.exam.isPass(currentUserExam)\" color=\"blue\">mdi-check</v-icon>\n              <v-icon v-else color=\"red\">clear</v-icon>\n            </template> "),
                _createElementVNode("div", _hoisted_6, _toDisplayString(oldestHistory.value.exam.name), 1 /* TEXT */)
              ]),
              (currentUserExam.value.startedAt)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(dateFormat(currentUserExam.value.startedAt)), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" 履歴がある時に、再テストのことなの、ランキング表示しなくてもいいです "),
              (isShowResult.value && !latestHistory.value.exam.isForUser && !latestHistory.value.exam.canRetest)
                ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, " ランキング " + _toDisplayString(currentUserExam.value.position) + " 位 / " + _toDisplayString(__props.exam.usersCount) + " 人中 ", 1 /* TEXT */),
                    _createElementVNode("span", _hoisted_10, "平均 " + _toDisplayString(latestHistory.value.exam.averageRate) + "%", 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", null, [
          (latestHistory.value.exam.isDone(currentUserExam.value) && latestHistory.value.exam.hideResult)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_v_btn, {
                  size: isMobile.value ? 'x-small' : 'small',
                  rounded: "",
                  color: "warning"
                }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createTextVNode(" 結果公開待ち", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["size"])
              ]))
            : (latestHistory.value.exam.isDone(currentUserExam.value) && currentUserExam.value.isWaitingScoreCheck)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(_component_v_btn, {
                    size: isMobile.value ? 'x-small' : 'small',
                    rounded: "",
                    color: "warning"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('exam_result.check_score')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["size"])
                ]))
              : (latestHistory.value.exam.isDone(currentUserExam.value))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: _normalizeClass(["exam-done", __props.onlyAction ? 'align-items-center' : 'align-items-end'])
                  }, [
                    _createVNode(ProgressRotate, {
                      score: currentUserExam.value.average,
                      value: currentUserExam.value.average,
                      color: !currentUserExam.value.passed ? 'red' : '#7dd420',
                      width: 3,
                      size: 60
                    }, null, 8 /* PROPS */, ["score", "value", "color"]),
                    (__props.exam.canRetest)
                      ? (_openBlock(), _createBlock(_component_v_menu, { key: 0 }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_btn, _mergeProps({ color: "black" }, props, {
                              class: "mt-2",
                              cytag: "retest-menu",
                              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                            }), {
                              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                _createTextVNode(" 再テストなど 🔽 ", -1 /* CACHED */)
                              ]))]),
                              _: 1 /* STABLE */
                            }, 16 /* FULL_PROPS */)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_14, [
                                  (__props.schoolSetting.useExamStock)
                                    ? (_openBlock(), _createBlock(_component_v_btn, {
                                        key: 0,
                                        class: "mt-3",
                                        rounded: "",
                                        color: 'warning',
                                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (reTest(latestHistory.value.exam, _unref(TYPE_USE_NIGATE_EXAM).toString())), ["stop"]))
                                      }, {
                                        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                          _createTextVNode("ニガテ問題を再テスト", -1 /* CACHED */)
                                        ]))]),
                                        _: 1 /* STABLE */
                                      }))
                                    : _createCommentVNode("v-if", true),
                                  (__props.schoolSetting.useExamStock)
                                    ? (_openBlock(), _createBlock(_component_v_btn, {
                                        key: 1,
                                        class: "mt-3",
                                        rounded: "",
                                        color: 'warning',
                                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (reTest(__props.exam, _unref(TYPE_USE_SPECIAL_EXAM).toString())), ["stop"]))
                                      }, {
                                        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                          _createTextVNode("別の問題で再テスト", -1 /* CACHED */)
                                        ]))]),
                                        _: 1 /* STABLE */
                                      }))
                                    : _createCommentVNode("v-if", true),
                                  _createVNode(_component_v_btn, {
                                    class: "mt-3",
                                    rounded: "",
                                    color: 'warning',
                                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (reTest(latestHistory.value.exam, _unref(TYPE_USE_EXAM_FROM_FAILED).toString())), ["stop"]))
                                  }, {
                                    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                      _createTextVNode("前回マチガイ再テスト", -1 /* CACHED */)
                                    ]))]),
                                    _: 1 /* STABLE */
                                  }),
                                  _createVNode(_component_v_btn, {
                                    class: "mt-3",
                                    rounded: "",
                                    color: 'warning',
                                    cytag: "retest",
                                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (reTest(__props.exam)), ["stop"]))
                                  }, {
                                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                      _createTextVNode(" 再テスト ", -1 /* CACHED */)
                                    ]))]),
                                    _: 1 /* STABLE */
                                  }),
                                  (__props.onShowHistories)
                                    ? (_openBlock(), _createBlock(_component_v_btn, {
                                        key: 2,
                                        class: "mt-3",
                                        rounded: "",
                                        color: 'warning',
                                        cytag: "showHistories",
                                        onClick: _cache[5] || (_cache[5] = _withModifiers(()=>{__props.onShowHistories(__props.exam)}, ["stop"]))
                                      }, {
                                        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                          _createTextVNode(" 今までのテスト結果を見る ", -1 /* CACHED */)
                                        ]))]),
                                        _: 1 /* STABLE */
                                      }))
                                    : _createCommentVNode("v-if", true),
                                  (oldestHistory.value.userExam.id != currentUserExam.value.id)
                                    ? (_openBlock(), _createBlock(DialogDeleteExamConfirm, {
                                        key: 3,
                                        title: "本当にテストを削除しますか？",
                                        onConfirmed: _cache[6] || (_cache[6] = ($event: any) => (confimClearHistoryTest(currentUserExam.value)))
                                      }))
                                    : _createCommentVNode("v-if", true)
                                ])
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : _createCommentVNode("v-if", true)
                  ], 2 /* CLASS */))
                : (_openBlock(), _createBlock(_component_v_btn, {
                    key: 3,
                    rounded: "",
                    color: latestHistory.value.exam.isTestTimeOver(currentUserExam.value) ? 'red' : 'primary',
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(gotoExam)(latestHistory.value.exam, currentUserExam.value)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(btnName(latestHistory.value.exam, currentUserExam.value)), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["color"]))
        ])
      ])
    ], 2 /* CLASS */),
    (__props.exam.canRetest && !isNoHistory.value && !__props.onShowHistories)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([!isMobile.value ? '' : '', 'mb-3'])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showingHistories.value, (history) => {
            return (_openBlock(), _createElementBlock("div", {
              key: history.userExam.id
            }, [
              _createVNode(_component_v_divider),
              _createElementVNode("div", {
                class: "py-1 px-2 d-flex justify-space-between exam-test align-center",
                onClick: ($event: any) => (goToUserExamHistory(history.exam, history.userExam))
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(history.title), 1 /* TEXT */),
                  (history.userExam.startedAt)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(dateFormat(history.userExam.startedAt)), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  (history.exam.isDone(history.userExam))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(history.userExam.average) + "% ", 1 /* TEXT */))
                    : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createVNode(_component_v_btn, {
                          size: "small",
                          rounded: "",
                          color: history.exam.isTestTimeOver(history.userExam) ? 'red' : 'primary',
                          onClick: ($event: any) => (_unref(gotoExam)(history.exam, history.userExam))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(history.btnName), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["color", "onClick"])
                      ])),
                  (oldestHistory.value.userExam.id != history.userExam.id)
                    ? (_openBlock(), _createBlock(DialogDeleteConfirm, {
                        key: 2,
                        title: "本当にテストを削除しますか？",
                        onConfirmed: ($event: any) => (confimClearHistoryTest(history.userExam))
                      }, null, 8 /* PROPS */, ["onConfirmed"]))
                    : _createCommentVNode("v-if", true)
                ])
              ], 8 /* PROPS */, _hoisted_15)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})